import React from "react";

interface DateIconProps {
  isActive?: boolean;
}

const DateIcon: React.FC<DateIconProps> = ({ isActive = false }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 3.33333H4.16667C3.24619 3.33333 2.5 4.07952 2.5 5V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V5C17.5 4.07952 16.7538 3.33333 15.8333 3.33333Z"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 8.33333H17.5"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 11.53333H17.5"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 14.63333H17.5"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 1.66667V5"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="2.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.66667 1.66667V5"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="2.0"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 10V17.6667"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10V17.6667"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 10V17.6667"
        stroke={isActive ? "#5b68d3" : "#6c757d"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DateIcon;
